import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import ClassificationMeter from '@components/charts/classificationMeter/index'
import { StatusContainer, ClassificationContainer } from '../styles'

const OverweigthStatus = ({
  overweightData, status, onChange, loading, beneficiaryWithCollectionCount
}) => {
  const { overweight } = overweightData || 0

  return (
    <StatusContainer>
      <ClassificationContainer>
        <ClassificationMeter
          loading={loading}
          type="overweight"
          status={status}
          onSelect={onChange}
          value={overweight}
          maxValue={beneficiaryWithCollectionCount}
        />
        {/* <ClassificationMeter
          loading={loading}
          type="overweightInRecovery"
          status={status}
          onSelect={onChange}
          value={overweightInRecovery}
          maxValue={beneficiaryWithCollectionCount}
        /> */}
      </ClassificationContainer>

    </StatusContainer>
  )
}

OverweigthStatus.propTypes = {
  loading: PropTypes.bool,
  overweightData: PropTypes.shape({
    overweight: PropTypes.number,
    overweightInRecovery: PropTypes.number,
  }),
  status: PropTypes.shape({
    overweight: PropTypes.bool,
    overweightInRecovery: PropTypes.bool,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  beneficiaryWithCollectionCount: PropTypes.number
}

OverweigthStatus.defaultProps = {
  loading: false,
  overweightData: null,
  beneficiaryWithCollectionCount: 0
}

const mapStateToProps = ({ overview, beneficiary }) => ({
  overweightData: overview.overweightData,
  beneficiaryWithCollectionCount: beneficiary.beneficiaryWithCollectionCount
})

export default connect(mapStateToProps, null)(OverweigthStatus)
